import React from "react";
import {LoanData} from "src/modules/flow/loan-details/model/LoanData";
import {CallForHelpLink} from "src/modules/app/tileable/instructions/contats/CallForHelpLink";
import {EmailForHelpLink} from "src/modules/app/tileable/instructions/contats/EmailForHelpLink";
import {FeeOptionKey} from "../../../../../loan-details/component/FeeSelector";

interface Props {
    loan: LoanData
    address: string;
    selectedFees?: FeeOptionKey[];
}

export class PrePayCreditCardInstructions extends React.Component<Props> {

    private getFeeTitle = () => {
        if (this.props.selectedFees && this.props.selectedFees.length > 0) {
            if (this.props.selectedFees.length === 1) {
                return this.props.selectedFees.includes("APPRAISAL") ? "Appraisal Fee." : "Credit Report Fee.";
            } else {
                return "Selected Fees.";
            }
        }

        if (this.props.loan.appraisalFeeEnabled && !this.props.loan.creditFeeEnabled) {
            return "Appraisal Fee.";
        } else if (!this.props.loan.appraisalFeeEnabled && this.props.loan.creditFeeEnabled) {
            return "Credit Report Fee.";
        }

        return "Appraisal Fee.";
    };

    private getFeeDescription = () => {
        if (this.props.selectedFees && this.props.selectedFees.length > 0) {
            const fees = [];
            if (this.props.selectedFees.includes("APPRAISAL")) {
                fees.push("Appraisal Fee");
            }
            if (this.props.selectedFees.includes("CREDIT_REPORT")) {
                fees.push("Credit Report Fee");
            }

            if (fees.length === 1) {
                return `This payment will cover the <strong>${fees[0]}</strong> that was required to complete your loan for the property at <strong>${this.props.address}</strong>.`;
            } else {
                return `This payment will cover the <strong>${fees.join(" and ")}</strong> that were required to complete your loan for the property at <strong>${this.props.address}</strong>.`;
            }
        }

        if (this.props.loan.appraisalFeeEnabled && !this.props.loan.creditFeeEnabled) {
            return `This payment will cover the <strong>Appraisal Fee</strong> that was required to complete your loan for the property at <strong>${this.props.address}</strong>.`;
        } else if (!this.props.loan.appraisalFeeEnabled && this.props.loan.creditFeeEnabled) {
            return `This payment will cover the <strong>Credit Report Fee</strong> that was required to complete your loan for the property at <strong>${this.props.address}</strong>.`;
        }

        return `This payment will cover the <strong>Appraisal Fee</strong> that was required to complete your loan for the property at <strong>${this.props.address}</strong>.`;
    };

    render() {
        return <>
            <h1>Pay your <br/>
                <span className="white-text">{this.getFeeTitle()}</span>
            </h1>
            <p dangerouslySetInnerHTML={{ __html: this.getFeeDescription() }} />

            <p>Have questions? You can always <CallForHelpLink support={this.props.loan.support}>call</CallForHelpLink>
                &nbsp;or&nbsp;
                <EmailForHelpLink support={this.props.loan.support}>email</EmailForHelpLink> your loan officer for help!
            </p>

        </>;
    }
}
